import { useContext } from 'react'
import { DateUtils } from '@ocean/utils'
import { DictionariesContext } from 'core/contexts'

const useUtcOffset = (timeZoneId?: string) => {
  const { dictionaries } = useContext(DictionariesContext)
  const { timeZones = [] } = dictionaries || {}
  return DateUtils.getNormalizedUtcOffset(timeZoneId, timeZones)
}

export default useUtcOffset
